module.exports = __webpack_public_path__ + "img/5d.160d4c47.png";